import styled from "styled-components";
import tw from "twin.macro";
import { Theme } from "../../context";

export const JiffyHeroContainer = styled.div<{ rooTheme?: Theme }>`
  ${tw`flex flex-col items-center justify-between w-full pt-10 font-clash lg:pt-20 pb-28 gap-14 lg:gap-0 lg:flex-row`}
  background: ${({ rooTheme }) => (rooTheme !== "dark" ? "white" : "#000")};
`;

export const JiffyContent = styled.div`
  flex-basis: 42%;
  align-items: flex-start;
`;

export const WelcomeJiffy = styled.h3`
  color: #007fff;
  ${tw`py-2 text-base font-medium font-clash`}
`;

export const JiffyLogistics = styled.h1<{ rooTheme?: Theme }>`
  ${tw`py-4 text-4xl font-bold md:text-5xl lg:text-6xl md:font-bold md:py-0 md:pb-2`};
  ${({ rooTheme }) =>
    rooTheme === "dark" ? tw`text-white ` : tw`text-basebackground`};
`;

export const JiffyLogisticsContent = styled.p<{ rooTheme?: Theme }>`
  ${tw`pb-5 w-[90%] md:w-[80%]`}
  ${({ rooTheme }) =>
    rooTheme === "dark" ? tw`text-gray-300 ` : tw`font-medium text-black`}
`;

export const JiffyImage = styled.img`
  width: 100%;
  cursor: pointer;
`;

export const JiffyImageContainer = styled.div`
  flex-basis: 53%;

  @media screen and (max-width: 1024px) {
    flex-basis: 53%;
  }
`;
